import { FC, useState } from "react";
import styled from "styled-components";

import FiltersDropdown from "@/components/FilterDropdown";
import FilterButton from "@/components/FilterDropdown/FilterButton";
import FilterRadioButton from "@/components/FilterDropdown/FilterRadioButton";
import {
  FilterGroupBody,
  FilterGroupHeader,
  FilterGroupTitle,
  FilterWrap,
} from "@/components/FilterDropdown/Parts";
import { months } from "./ApprovedBonusesTable";

const StyledFiltersDropdown = styled(FiltersDropdown)`
  max-height: 418px;
`;

export enum Periods {
  LAST_90_DAYS = "-90 days",
  ALL_TIME = "",
}

const renderPeriodTitle = (period: Periods) => {
  switch (period) {
    case Periods.LAST_90_DAYS:
      return "Last 90 days";
    default:
      return "All time";
  }
};

interface Props {
  activePeriod: {
    type: "month" | "period";
    period: string;
  };
  setActivePeriod: React.Dispatch<
    React.SetStateAction<{
      type: "month" | "period";
      period: string;
    }>
  >;
}

const GamificationDateFilter: FC<Props> = ({
  activePeriod,
  setActivePeriod,
}) => {
  const [showFilters, setShowFilters] = useState(false);

  return (
    <FilterWrap>
      <FilterButton
        text="Date"
        isActive={showFilters}
        onClick={(e) => {
          e?.stopPropagation();
          setShowFilters((prev) => !prev);
        }}
        filterApplied
      />
      {showFilters && (
        <StyledFiltersDropdown onClose={() => setShowFilters(false)}>
          <FilterGroupHeader>
            <FilterGroupTitle>By Period:</FilterGroupTitle>
          </FilterGroupHeader>
          <FilterGroupBody>
            {Object.values(Periods).map((period, index) => (
              <FilterRadioButton
                key={index}
                id={`periodRadio${index}`}
                value={period}
                checked={activePeriod.period === period}
                setValue={(newValue) =>
                  setActivePeriod({
                    period: newValue,
                    type: "period",
                  })
                }
              >
                {renderPeriodTitle(period)}
              </FilterRadioButton>
            ))}
          </FilterGroupBody>
          <FilterGroupHeader>
            <FilterGroupTitle>By Month:</FilterGroupTitle>
          </FilterGroupHeader>
          <FilterGroupBody>
            {months.map((dt, index) => (
              <FilterRadioButton
                key={index}
                id={`monthRadio${index}`}
                value={dt.startOf("month").toFormat("yyyy-LL-dd")}
                checked={
                  activePeriod.period ===
                  dt.startOf("month").toFormat("yyyy-LL-dd")
                }
                setValue={(newValue) =>
                  setActivePeriod({
                    period: newValue,
                    type: "month",
                  })
                }
              >
                {dt.toFormat("yyyy LLLL")}
              </FilterRadioButton>
            ))}
          </FilterGroupBody>
        </StyledFiltersDropdown>
      )}
    </FilterWrap>
  );
};

export default GamificationDateFilter;
